<template>
  <div class="bgImage w-screen mx-auto h-screen md:h-auto">
    <div class="text-center bg-background-academy bg-opacity-50 h-screen">
      <div class="title pt-10 md:pt-20 lg:pt-40">
        <h1 class="text-xl md:text-2xl text-white">{{ $t('register.title') }}</h1>
      </div>
      <div class="flex flex-col items-center pb-5">
        <div
          class="mt-6 md:mt-16 text-white text-lg md:text-xl pb-1">
              {{ $t('register.masterclass') }}
        </div>
        <form
          class="flex flex-col justify-center mx-auto text-md md:text-lg
          text-grey-academy-800 pb-10 w-full md:w-auto px-5 md:px-0"
          action="#"
          @submit.prevent="submit">
            <div class="flex flex-col md:flex-row">
              <input
                type="text" v-model="credentials.firstname"
                class="mt-10 border-b-4 border-orange-academy-300 h-12 px-3 outline-none
                bg-beige-academy-100 font-sans-serif md:mr-4"
                :placeholder="$t('register.first')">
              <div v-if="errors.errors.firstname"
                class="px-2 text-sm text-left text-orange-academy-300 font-sans-serif
                bg-white font-bold py-1">
                {{ errors.errors.firstname[0] }}</div>
              <input
                type="text" v-model="credentials.lastname"
                class="mt-10 border-b-4 border-orange-academy-300 h-12 px-3 outline-none
                bg-beige-academy-100 font-sans-serif"
                :placeholder="$t('register.last')">
              <div v-if="errors.errors.lastname"
                class="px-2 text-sm text-left text-orange-academy-300 font-sans-serif
                bg-white font-bold py-1">
                {{ errors.errors.lastname[0] }}</div>

            </div>

            <div class="flex flex-col">
                <input
                  type="email" v-model="credentials.email"
                  class="mt-10 border-b-4 border-orange-academy-300 h-12 px-3 outline-none
                  bg-beige-academy-100 font-sans-serif"
                  placeholder="Email">
                <div v-if="errors.errors.email"
                  class="px-2 text-sm text-left text-orange-academy-300 font-sans-serif
                  bg-white font-bold py-1">
                  {{ errors.errors.email[0] }}</div>
                <input
                  type="password" v-model="credentials.password"
                  class="mt-10 border-b-4 border-orange-academy-300 h-12 px-3 outline-none
                  bg-beige-academy-100 font-sans-serif"
                  placeholder="Password">
                <div v-if="errors.errors.password"
                  class="px-2 text-sm text-left text-orange-academy-300 font-sans-serif
                  bg-white font-bold py-1">
                  {{ errors.errors.password[0] }}</div>
                <input
                  type="Password" v-model="credentials.password_confirmation"
                  class="mt-10 border-b-4 border-orange-academy-300 h-12 px-3 outline-none
                  bg-beige-academy-100 font-sans-serif"
                  :placeholder="$t('register.confirm')">
                <div v-if="errors.errors.password_confirmation"
                  class="px-2 text-sm text-left text-orange-academy-300 font-sans-serif
                  bg-white font-bold py-1">
                  {{ errors.errors.password_confirmation[0] }}</div>
            </div>
            <button
              class="w-1/2 sm:w-1/3 mx-auto mt-10 bg-orange-academy-300 text-grey-academy-100 p-2
              rounded-md hover:text-orange-academy-300 hover:bg-grey-academy-100 shadow-md
                border border-orange-academy-300 font-sans-serif uppercase"
              type="submit">
                {{ $t('register.register') }}
            </button>
        </form>
        <span class="text-white font-sans-serif">
          {{ $t('register.asTeacher') }}
        <br>
        <strong>info@e-cademymusic.com</strong>
        </span>
      </div>
      <span class="pt-12 font-sans-serif text-white pb-20 md:pb-0">
          {{ $t('register.login') }}
          <router-link to="/signin" class="rounded text-orange-academy-300 py-2 px-4 ml-2
            uppercase border border-orange-academy-300 hover:bg-orange-academy-300
            hover:text-grey-academy-100 bg-white font-sans-serif">
              {{ $t('header.login') }}
          </router-link>
        </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import getBrowserLocale from '@/util/i18n/get-browser-locale';
import Errors from '@/util/Errors';

export default {
  mixins: [StreamFunctionsMixin],

  data() {
    return {
      credentials: {
        firstname: '',
        lastname: '',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        user_type: 'student',
        lang: getBrowserLocale.getBrowserLocale(),
      },

      errors: new Errors(),
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      localTimezone: 'timezone/localTimezone',
    }),
  },

  methods: {
    ...mapActions({
      register: 'auth/register',
      saveTimezone: 'auth/saveTimezone',
    }),

    async submit() {
      this.credentials.name = `${this.capitalLetter(this.credentials.firstname)} ${this.capitalLetter(this.credentials.lastname)}`;
      this.register(this.credentials).then(async () => {
        this.createNotification('success', `${this.$t('notifications.registration')}`);
        await this.saveTimezone(this.localTimezone);
        this.$router.push('/verify-email');
        this.isLoading = false;
      }).catch((errors) => {
        this.isLoading = false;
        this.errors.record(errors.response.data.errors);
      });
    },

  },

};
</script>

<style lang="scss" scoped>
  .bgImage {
    background-image: url("../images/Harp Ecademy.jpg");
    background-size: cover;
    height: 100%;
  }
  ::placeholder {
    color: gray;
    opacity: 0.75;
  }
</style>
